import React, { Component } from 'react';
//import swal from 'sweetalert';
//import apeConfirmation from '../images/ape_confirmation.png';
//import highapeLogo from '../images/highape_logo.png';
import headerSSL from '../images/ssl-logo.png';

class HeaderAreaCheckout extends Component {

  render() {
    return (
        <div className="desktopHeader col-sm-12 col-xs-12">
          <div className="col-sm-4 col-xs-12">
            <img className="desktop_logo_highape" src="https://res.cloudinary.com/https-highape-com/image/upload/v1730898829/highape_footer_iv8ylu.png" alt="Logo of HighApe" />
          </div>
          <div className="col-sm-4 col-xs-12 secure_header_title">
            Secure Payment
          </div>
          <div className="col-sm-4 col-xs-12">
            <img className="header_ssl_icon" src={headerSSL} alt="SSL Icon" />
            <p className="ticket_query_text desktop_ticket_query">Email: contact@highape.com | WhatsApp: +91-8618286048</p>
          </div>
        </div>
    );
  }
}

/*
class Timer extends Component {

  constructor(props) {
    super(props);
    this.state = { time: {}, seconds: 479 };
    this.timer = 0;
    this.startTimer = this.startTimer.bind(this);
    this.countDown = this.countDown.bind(this);
  }

  secondsToTime(secs){
    let hours = Math.floor(secs / (60 * 60));

    let divisor_for_minutes = secs % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);

    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = Math.ceil(divisor_for_seconds);
    if(seconds<10){
      seconds = '0' + seconds;
    }
    let obj = {
      "h": hours,
      "m": minutes,
      "s": seconds
    };

    return obj;
  }

  componentDidMount() {
    let timeLeftVar = this.secondsToTime(this.state.seconds);
    this.setState({ time: timeLeftVar });
  }

  startTimer() {
    if (this.timer === 0) {
      this.timer = setInterval(this.countDown, 1000);
    }
  }

  countDown() {
    // Remove one second, set state so a re-render happens.
    let seconds = this.state.seconds - 1;
    this.setState({
      time: this.secondsToTime(seconds),
      seconds: seconds,
    });
    
    // Check if we're at zero.
    if (seconds === 0) { 
      swal("Time Up!", " You will now be redirected back to the event page. Please start your booking again.")
      .then((value) => {
        window.location = "https://highape.com/"+this.props.city+"/events/"+this.props.event_perma; //if 0 then redirect back to the event page
      });
      clearInterval(this.timer);
    }
  }

  render() {
    return(
      <div className="time_left_div">
      {this.startTimer()}    
        <span className="time_left">Time Left: </span>
        <span className="time_left_timer">{this.state.time.m}:{this.state.time.s}</span>
      </div>
    );
  }
}
*/



export default HeaderAreaCheckout;


// WEBPACK FOOTER //
// ./src/desktop/desktopPaymentHeader.js